import { getChainById } from '../config/chains';

/**
 * Get the block explorer URL for a transaction hash on a given chain
 * @param {string|number} chainId - The chain ID (can be decimal, hex, or CHAINS config key)
 * @param {string} txHash - The transaction hash
 * @returns {string|null} - The explorer URL or null if chain not found
 */
export const getExplorerTxUrl = (chainId, txHash) => {
    if (!chainId || !txHash) return null;

    // Prefer config-key / shared resolver so mainnet vs testnet explorers
    // (arbiscan.io vs sepolia.arbiscan.io) are never swapped.
    const chain = getChainById(chainId);
    
    if (!chain || !chain.blockExplorerUrl) {
        return null;
    }
    
    // Construct the explorer URL
    // Most explorers use /tx/ for transaction URLs
    const explorerUrl = chain.blockExplorerUrl.replace(/\/$/, ''); // Remove trailing slash
    return `${explorerUrl}/tx/${txHash}`;
};
